<template>
  <div class="head-selection">
    <div class="left-selection">
      <div @click="gotoHome" :class="routers.indexOf('about')==-1?'logo':'logo-tow'"></div>

      <!-- <div class="logo"></div> -->
      <div
        style="cursor:pointer"
        @click="gotoProduct"
        :style="{color:colorMark == 'production'?'#ff6222':''}"
        class="fontSizeSet"
      >能力</div>
      <div
        style="cursor:pointer"
        @click="gotoaiPage"
        :style="{color:colorMark == 'aiPage'?'#ff6222':''}"
        class="fontSizeSet"
      >产品</div>
      <Dropdown style="display:none">
        <a
          href="javascript:void(0)"
          :style="{color:colorMark.indexOf('case')>=0?'#ff6222':''}"
          class="fontSizeSet"
        ></a>
        <DropdownMenu slot="list">
          <DropdownItem>
            <div
              @click="gotoScenarios"
              :style="{color:colorMark == 'scenarioscase'?'#ff6222':''}"
            >应用场景</div>
          </DropdownItem>
          <DropdownItem>
            <div @click="gotoCase1" :style="{color:colorMark == 'case1'?'#ff6222':''}">智能运维案例</div>
          </DropdownItem>
          <DropdownItem>
            <div @click="gotoCase2" :style="{color:colorMark == 'case2'?'#ff6222':''}">智能商业决策案例</div>
          </DropdownItem>
          <Dropdown placement="right-start">
            <DropdownItem>智慧城市案例
              <Icon type="ios-arrow-forward"></Icon>
            </DropdownItem>
            <DropdownMenu slot="list">
              <DropdownItem>
                <div
                  @click="gotoCase3_1"
                  :style="{color:colorMark == 'case3_1'?'#ff6222':''}"
                >某交通管理部门</div>
              </DropdownItem>
              <DropdownItem>
                <div @click="gotoCase3_2" :style="{color:colorMark == 'case3_2'?'#ff6222':''}">某海事局</div>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
          <DropdownItem>
            <div @click="gotoCase4" :style="{color:colorMark == 'case4'?'#ff6222':''}">精准画像案例</div>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <div
        style="margin-right:190px"
        class="fontSizeSet"
        @click="gotoAbout"
        :style="{color:colorMark == 'about'?'#ff6222':''}"
      >关于</div>
    </div>

    <div v-if="false" class="right-selection">
      <!-- <div>设置</div> -->
      <a href="https://uc.youzidata.com/register/toLogin.html">
        <div class="new_login new_login_bcon1"></div>
      </a>
      <a href="https://uc.youzidata.com/register/toRegister.html">
        <div class="new_login new_login_bcon2"></div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "headSelection",
  props: {
    msg: String
  },
  data() {
    return {
      colorMark: " ",
      routers:''
    };
  },
  destroyed() {
    window.localStorage.setItem('chosenMark','')
  },
  created: function() {},
  mounted: function() {
    this.routers = this.$route.fullPath
    this.colorMark = window.sessionStorage.getItem('chosenMark')
      ? window.sessionStorage.getItem('chosenMark')
      : " ";
  },
  methods: {
    gotoaiPage() {
      this.colorMark = "aiPage";
      window.sessionStorage.chosenMark = "aiPage";
      window.localStorage.setItem('chosenMark','aiPage')
      // window.scrollTo(0, 0);
      this.$router.push({ path: "aiPage" });
    },
    gotoHome() {
      this.colorMark = " ";
      window.localStorage.chosenMark = " ";
      window.sessionStorage.setItem('chosenMark','')
      // window.scrollTo(0, 0);
      this.$router.push({ path: "/" });
    },
    gotoProduct() {
      this.colorMark = "production";
      window.localStorage.chosenMark = "production";
      window.sessionStorage.setItem('chosenMark','production')
      // window.scrollTo(0, 0);
      this.$router.push({ path: "production" });
    },
    gotoAbout: function() {
      this.colorMark = "about";
      window.localStorage.chosenMark = "about";
      window.sessionStorage.setItem('chosenMark','about')
      // window.scrollTo(0, 0);
      this.$router.push({ path: "about" });
    },
    gotoScenarios: function() {
      this.colorMark = "scenarioscase";
      window.localStorage.chosenMark = "scenarioscase";
      // window.scrollTo(0, 0);
      this.$router.push({ path: "scenarios" });
    },
    gotoCase1: function() {
      this.colorMark = "case1";
      window.localStorage.chosenMark = "case1";
      // window.scrollTo(0, 0);
      this.$router.push({ path: "case1" });
    },
    gotoCase2: function() {
      this.colorMark = "case2";
      window.localStorage.chosenMark = "case2";
      // window.scrollTo(0, 0);
      this.$router.push({ path: "case2" });
    },
    gotoCase3_1: function() {
      this.colorMark = "case3_1";
      window.localStorage.chosenMark = "case3_1";
      // window.scrollTo(0, 0);
      this.$router.push({ path: "case3_1" });
    },
    gotoCase3_2: function() {
      this.colorMark = "case3_2";
      window.localStorage.chosenMark = "case3_2";
      // window.scrollTo(0, 0);
      this.$router.push({ path: "case3_2" });
    },
    gotoCase4: function() {
      this.colorMark = "case4";
      // window.scrollTo(0, 0);
      window.localStorage.chosenMark = "case4";
      this.$router.push({ path: "case4" });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.head-selection {
  min-width: 1000px;
  max-width: 1280px;
  margin: 0 auto;
  @include fullSize;
  @include aroundLine;
  justify-content: space-between;
  font-size: calc(var(--bili) * 14);
  .fontSizeSet{
    padding-top:calc(var(--bili) * 8);;
  }
  .left-selection {
    .chonsen_color {
      color: #ff6222;
    }
    @include betweenLine;
    width: calc(var(--bili) * 750);
    height: 100%;
    .logo {
      background: url("../commonImages/logo-black.png");
      @include fullbackground;
      width: calc(var(--bili) * 120);
      height: calc(var(--bili) * 70);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }
    .logo-tow {
      background: url("../commonImages/logo-white.png") no-repeat;
      background-size: 100%;
      @include fullbackground;
      width: calc(var(--bili) * 120);
      height: calc(var(--bili) * 70);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }
    .toggleLogo {
      background-image: url("../commonImages/logo-white.png");
    }

    & > div {
      cursor: pointer;
    }
    & > div:hover {
      color: $fontColor;
    }
  }
  .right-selection {
    .new_login {
      background-repeat: no-repeat;
      background-size: contain;
      width: calc(var(--bili) * 30);
      height: calc(var(--bili) * 30);
      margin-right: calc(var(--bili) * 40);
    }
    .new_login_bcon1 {
      background-image: url("../commonImages/login_bg1.png");
    }
    .new_login_bcon2 {
      background-image: url("../commonImages/login_bg2.png");
    }
    .new_login_bcon3 {
      background-image: url("../commonImages/login_bg1_1.png");
    }
    .new_login_bcon4 {
      background-image: url("../commonImages/login_bg2_1.png");
    }
    @include betweenLine;
    justify-content: flex-end;
    width: calc(var(--bili) * 300);
    height: 100%;
    .login {
      width: calc(var(--bili) * 100);
      height: calc(var(--bili) * 40);
      border: 1px solid $fontColor;
      color: $fontColor;
      @include centerLine;
    }
    & > div {
      font-size: calc(var(--bili) * 16);
      cursor: pointer;
    }
    & > div:hover {
      color: $fontColor;
    }
  }
}
</style>
